import { z } from "zod/v4";
import { getCaja } from "../../caja-list/api/get-caja";
import { getAllCajas } from "../../caja-list/api/get-all-cajas";
import { Form, FormProps } from "@/components/form";
import { Stack } from "@mui/material";

export const cajaAssignFormSchema = z.object({
    cajaId: z.string()
})

export default function CajaAssignForm({
    form,
    ...props
}: FormProps<z.input<typeof cajaAssignFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Stack maxWidth={"350px"}>
            <Form.ModelComboBox name="cajaId" label="Caja" get={getCaja} getAll={getAllCajas} size="small" />
        </Stack>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"end"}>
            <Form.SubmitButton>Guardar</Form.SubmitButton>
        </Stack>
    </Form>
}